import { observer } from 'mobx-react-lite'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { deferAction } from 'reusable/utils/utils'
import { useRouterStore } from '../../RouterStore'

/** this is the index route. Will redirect to the appropriate route whenever it is hit */
export default observer(function RouteRedirect() {
   const routerStore = useRouterStore()

   useInitialMount(() => {
      deferAction(() => {
         routerStore.navigateToOrgsDefault()
      });
   })

   return null
}
)